export const CARD_FILTER_I18N = {
  en: {
    allLabel: 'All',
    resultsLabel: (filtered: number, total: number, result: string) => `Showing ${filtered} of ${total} ${result}`,
  },
  fr: {
    allLabel: 'Tout afficher',
    resultsLabel: (filtered: number, total: number, result: string) => `${filtered} de ${total} ${result}`,
  },
}
